
import { onMounted, nextTick, watch, ref } from 'vue'
import store from '@/store/index'
export default {
  name: 'QuestionTile',
  props: {
    questionData: { type: Object, default: () => ({}) },
    questionIndex: { type: Number, default: 0 },
    retryNum: { type: Number, default: 0 },
    showTotal: { type: Boolean, default: true }
  },
  setup(props) {
    const queTypeDes = ref(props.questionData?.list?.logicQuesTypeName || '')
    const total = ref(props.questionData?.total || 0)
    const isDecidable = ref(props.questionData?.list?.isDecidable)

    // 渲染题目信息
    const renderQuestion = () => {
      let data = props.questionData
      let questionIndex = props.questionIndex
      nextTick(() => {
        window?.['TalqsInteraction']?.setUserConfig(store.getters.talqsInteractionConfig)
        let questionTitleDom: any = document.getElementById(`questionTitle_${questionIndex}`)
        try {
          questionTitleDom.innerHTML = (window as any).TalqsTemplate.render(data.list, {
            hideDifficulty: true,
            hideSource: true,
            hideCamera: true
          })
          ;(window as any).MathJax.Hub.Queue([
            'Typeset',
            (window as any).MathJax.Hub,
            questionTitleDom
          ])
          // (window as any).TalqsTemplate.autoLayout();
          window['TalqsInteraction'].initTqiQs()
        } catch (e) {
          console.log('error', e)
        }
      })
    }

    watch(
      () => props.retryNum,
      () => renderQuestion(),
      { immediate: true }
    )
    onMounted(() => renderQuestion())

    return {
      queTypeDes,
      total,
      isDecidable
    }
  }
}
